import React, { useEffect, useState } from "react";
import { Button } from "../../../components/client/Button/Button";
import { MainLayout } from "../../../layout/MainLayout";
import Countdown from "react-countdown";
import { useParams } from "react-router-dom";
import { Helmet } from "react-helmet";
import { HOST } from "../../../config";
import { PieChart } from "react-minimal-pie-chart";


export default function Exam() {
  const { examId } = useParams();
  const [data, setData] = useState([]);
  const [currentData, setCurrentData] = useState({});
  const [currentQuestionId, setCurrentQuestionId] = useState(0);
  const [isNext, setIsNext] = useState(true);
  const [isPrev, setIsPrev] = useState(false);
  const [answer, setAnswer] = useState({});
  const [isResult, setIsResult] = useState(false);
  const [isShowAnswer, setIsShowAnswer] = useState(false);
  const [timer, setTimer] = useState(Date.now() + 1200000);
  const [totalSuccess, setTotalSuccess] = useState(0);
  const [urlResult, setUrlResult] = useState("");
  const [dataPie, setDataPie] = useState([]);

  const renderer = ({ hours, minutes, seconds, completed }) => {
    if (completed) {
      handleDoneExam();
    } else {
      return (
        <span>
          {minutes < 10 ? "0" + minutes : minutes}:
          {seconds < 10 ? "0" + seconds : seconds}
        </span>
      );
    }
  };

  useEffect(() => {
    const requestOptions = {
      method: "GET",
      redirect: "follow",
    };

    fetch(`${HOST}/exam/${examId}/question`, requestOptions)
      .then((response) => response.text())
      .then((result) => {
        const res = JSON.parse(result);
        setData(res);
        setCurrentData(res[0]);
        setCurrentQuestionId(0);
        console.log(res);
      })
      .catch((error) => console.log("error", error));
  }, []);

  function handlePickQuestion(i) {
    setCurrentData(data[i]);
    setCurrentQuestionId(i);

    if (i >= data.length - 1) {
      setIsNext(false);
      setIsPrev(true);
    }
    if (i === 0) {
      setIsNext(true);
      setIsPrev(false);
    }

    if (i > 0 && i < data.length - 1) {
      setIsNext(true);
      setIsPrev(true);
    }

    if (isResult) {
      setIsShowAnswer(true);
      setIsResult(false);
    }
  }

  function resetExam() {
    setCurrentData(data[0]);
    setCurrentQuestionId(0);
    setIsNext(true);
    setIsPrev(false);
    setAnswer({});
    setIsResult(false);
    setIsShowAnswer(false);
  }

  function handleCheckAnswer(e, answerId) {
    const iCheck = e.target.checked;
    if (!answer[currentQuestionId]) {
      answer[currentQuestionId] = [];
    }
    if (iCheck) {
      answer[currentQuestionId].push(answerId);
      answer[currentQuestionId] = [...new Set(answer[currentQuestionId])];
    } else {
      answer[currentQuestionId] = answer[currentQuestionId].filter(
        (item) => !item.answerId
      );
    }

    setAnswer(answer);
  }

  function handleDoneExam() {
    let totalSuccess = 0;
    for (let i = 0; i < data.length; i++) {
      const element = data[i];
      const answerList = element.answer;
      if (!answer[i]) {
        continue;
      }
      const getAnswer = answer[i];
      for (const ans of answerList) {
        if (getAnswer.includes(ans.answerId) && ans.isCorrect) {
          totalSuccess = totalSuccess + 1;
        }
      }
    }

    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    const dataSend = {
      totalSuccess,
      total: data.length,
    };
    const raw = JSON.stringify({
      type: "exam",
      value: JSON.stringify(dataSend),
    });

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    fetch(`${HOST}/resource/result`, requestOptions)
      .then((response) => response.text())
      .then((result) => {
        const res = JSON.parse(result);
        const id = res.id;

        const pie = [
          { title: "Đúng", value: totalSuccess, color: "#E38627" },
          { title: "Sai", value: data.length - totalSuccess, color: "#C13C37" },
        ]

        setDataPie(pie)

        setUrlResult(`${HOST}/resource/result/exam-result/` + id);
        setTotalSuccess(totalSuccess);
        setIsResult(true);
      })
      .catch((error) => console.log("error", error));
  }

  

  return (
    <MainLayout>
      <Helmet>
        <title>Đề thi số {examId}</title>
      </Helmet>
      <div className="grid grid-cols-1 lg:grid-cols-3">
        <div className="border-r-[1px] p-2">
          <p className="border-b-[1px] mb-2 font-bold text-lg">Câu hỏi</p>
          {data?.map((item, i) => {
            return currentQuestionId === i ? (
              <Button
                key={i}
                className="mr-2 mb-2 min-w-[40px] text-white font-bold"
                onClick={() => handlePickQuestion(i)}
              >
                {item.questionName}
              </Button>
            ) : (
              <Button
                key={i}
                className="mr-2 mb-2 min-w-[40px] bg-[#eeeeee] text-black font-bold"
                onClick={() => handlePickQuestion(i)}
              >
                {item.questionName}
              </Button>
            );
          })}
          <div></div>
          <Button
            onClick={resetExam}
            className="w-full bg-[#eeeeee] text-black"
          >
            Làm lại đề thi
          </Button>
        </div>

        {isResult ? (
          <div className="col-span-2 p-2 text-center">
            <div className=" p-3 w-[500px] m-auto">
              <PieChart
                viewBoxSize={[100, 100]}
                label={({ dataEntry }) => `${dataEntry.value} ${dataEntry.title}`}
                labelStyle={(index) => ({
                  fill: dataPie[index].color,
                  fontSize: '5px',
                  fontFamily: 'sans-serif',
                })}
                lineWidth={20}
                labelPosition={60}
                data={dataPie}
              />
            </div>
            <div className="text-left">
              Có {data.length} câu hỏi. Bạn trả lời đúng {totalSuccess} câu, sai{" "}
              {data.length - totalSuccess} câu.
            </div>
            <p>Link kết quả</p>
            <a href={urlResult} target="_blank" className="bg-yellow-500">
              {urlResult}
            </a>
            <div className="flex justify-between items-center p-1 mb-2">
              <Button className="min-w-[40px]" onClick={resetExam}>
                Làm lại đề thi
              </Button>
              <Button
                className="min-w-[40px]"
                onClick={() => handlePickQuestion(0)}
              >
                Xem đáp án
              </Button>
              <Button className="min-w-[40px]" aria-current="page">
                Làm đề thi khác
              </Button>
              <a
                href={"https://www.facebook.com/share.php?u=" + urlResult}
                className="bg-[#a0214e] text-white p-2 min-w-[40px]"
                aria-current="page"
              >
                Chia sẻ facebook
              </a>
            </div>
          </div>
        ) : (
          <div className="col-span-2 p-2">
            {isResult || isShowAnswer ? (
              <div className="flex justify-between items-center bg-[#eeeeee] p-1 mb-2">
                <p>Bài thi đã kết thúc</p>
              </div>
            ) : (
              <div className="flex justify-between items-center bg-[#eeeeee] p-1 mb-2">
                <p>
                  Thời gian làm bài:{" "}
                  <Countdown date={timer} renderer={renderer} />
                </p>
                <p>Số lượng câu đã làm: {Object.keys(answer).length}</p>
                <div>
                  <Button
                    className="min-w-[40px] bg-[#0062b5]"
                    onClick={handleDoneExam}
                  >
                    Nộp bài
                  </Button>
                </div>
              </div>
            )}
            <p className="mb-2 text-[#0062b5] font-bold">
              Câu hỏi {currentData?.questionName} :
            </p>
            <p className="mb-2">{currentData?.questionText}</p>
            {currentData?.questionImage && (
              <img
                alt=""
                src={currentData?.questionImage}
              />
            )}
            {currentData?.answer &&
              currentData.answer.map((item, index) => {
                return (
                  <div key={item.answerId} className="mb-2">
                    <input
                      onClick={(e) => handleCheckAnswer(e, item.answerId)}
                      type="checkbox"
                      id={index}
                      defaultChecked={
                        answer[currentQuestionId]?.includes(item.answerId)
                          ? true
                          : false
                      }
                      className="default:ring-2 checked:bg-blue-500"
                    />
                    <label
                      htmlFor={index}
                      className="peer-checked/published:text-sky-500 px-1"
                    >
                      {item.answerText}{" "}
                      {isShowAnswer && item?.isCorrect && (
                        <span className="text-green-400"> - Đáp án đúng</span>
                      )}
                    </label>
                  </div>
                );
              })}
            <div className="flex justify-between">
              {isPrev ? (
                <Button
                  className="mr-2 mb-2 min-w-[40px] self-end"
                  onClick={() => {
                    handlePickQuestion(currentQuestionId - 1);
                  }}
                >
                  Câu trước
                </Button>
              ) : (
                <span></span>
              )}
              {isNext ? (
                <Button
                  className="mr-2 mb-2 min-w-[40px] self-end"
                  onClick={() => {
                    handlePickQuestion(currentQuestionId + 1);
                  }}
                >
                  Câu tiếp theo
                </Button>
              ) : (
                <span></span>
              )}
            </div>
          </div>
        )}
      </div>
    </MainLayout>
  );
}
